const footerDataFR = {
  homepage: "/fr/",
  categories: [
    {
      title: "Entreprise",
      links: [
        {
          text: "Trust center",
          href: "/trust-center/"
        },
        {
          //text: "Événements",
          text: "Events",
          href: "/events/",
        },
        {
          //text: "À propos de nous",
          text: "About us",
          href: "/about-us/",
        },
        {
          //text: "Emplois",
          text: "Jobs",
          href: "/jobs/",
        },
        {
          //text: "Développement durable",
          text: "Sustainability",
          href: "/greener-hosting/",
        },
        {
          text: "FAQ",
          href: "/faq/",
        },
        {
          text: "Open source",
          href: "/community/open-source/",
        }
      ],
    },
    {
      title: "Produit",
      links: [
        {
          text: "Aperçu",
          href: "/fr/produit/",
        },
        {
          //text: "Fonctionnalités",
          text: "Features",
          href: "/features/",
        },
        {
          //text: "Tarification",
          text: "Pricing",
          href: "/pricing/",
        },
        {
          // TODO: translate
          text: "Pricing calculator",
          href: "/pricing/calculator/"
        }
      ],
    },
    {
      title: "Industries",
      links: [
        {
          text: "Vente au détail",
          href: "/fr/industrie/vente-au-detail/"
        },
        {
          text: "Enseignement supérieur",
          href: "/fr/industrie/enseignement-superieur/"
        },
        {
          text: "SaaS",
          href: "/fr/industrie/saas/"
        },
        {
          text: "Voyage et hôtellerie",
          href: "/fr/industrie/voyages-et-hotellerie/"
        },
        {
          text: "Services financiers",
          href: "/fr/industrie/services-financiers/"
        },
        {
          text: "Gouvernement",
          href: "/fr/industrie/gouvernement/"
        },
      ]
    },
    {
      title: "Ressources",
      links: [
        {
          text: "Études de cas",
          href: "/fr/blog/etudes-de-cas/"
        },
        {
          text: "Blog",
          href: "/fr/blog/",
        },
        {
          //text: "Développeurs",
          text: "Developers",
          href: "https://devcenter.upsun.com/",
        },
        {
          text: "Documentation",
          href: "https://docs.upsun.com/",
        },
        {
          // TODO: translate
          text: "Cloud regions",
          href: "/regions/",
        },
        {
          text: "Assistance",
          href: "https://console.upsun.com/-/users/:user/tickets/open",
        },
        {
          //text: "Nous contacter",
          text: "Contact us",
          href: "/contact-us/",
        }
      ],
    },
    {
      title: "Cas d'utilisation",
      links: [
        {
          text: "Hébergement SaaS",
          href: "/fr/solutions/saas/"
        },
        {
          text: "Application modernisation",
          href: "/fr/solutions/application-modernisation/"
        },
        {
          text: "Commerce électronique",
          href: "/fr/solutions/commerce-electronique/"
        },
        {
          text: "Hébergement CMS",
          href: "/fr/solutions/cms/"
        },
        {
          text: "Gestion multi sites",
          href: "/fr/solutions/gestion-multi-sites/"
        },
        { 
          text: "Extensions SaaS",
          href: "/fr/solutions/saas-extensions/"
        },
        {
          text: "Solutions backend",
          href: "/fr/solutions/backend/"
        },
      ]
    },
    {
      title: "Comparer",
      links: [
        {
          text: "Alternative à Heroku",
          href: "/fr/alternative-a-heroku/"
        },
        {
          text: "Alternative à Pantheon",
          href: "/fr/pantheon-alternative/"
        },
        {
          text: "Alternative à l'hébergement géré",
          href: "/fr/hebergement-gere-alternatif/"
        },
        {
          text: "Alternative à Fly.io",
          href: "/fr/fly-io-alternative/"
        },
        {
          text: "Alternative à Render",
          href: "/fr/render-alternative/"
        },
        {
          text: "Alternative à AWS",
          href: "/fr/aws-alternative/"
        },
        {
          text: "Alternative à Acquia",
          href: "/fr/acquia-alternative/"
        },
      ]
    }
  ],
  bottomLinks: [
    {
      href: "/trust-center/legal/tos/",
      //text: "Conditions d’utilisation",
      text: "Terms of Service",
    },
    {
      href: "/trust-center/privacy/privacy-notice/",
      //text: "Politique de confidentialité",
      text: "Privacy",
    },
    {
      href: "/trust-center/legal/impressum/",
      //text: "Mentions légales",
      text: "Impressum",
    },
    {
      href: "/trust-center/security/responsible-disclosure/",
      //text: "Signaler un problème de sécurité",
      text: "Report a security issue",
    },
  ],
};

export default footerDataFR;
